import { useCallback, useContext, useEffect, useState } from 'react';
import { Network } from '@capacitor/network';
import type { ConnectionStatus, ConnectionType } from '@capacitor/network';
import { ContextApp } from '../contexts/ContextApp';

const unavailableStatus: ConnectionStatus = {
  connected: false,
  connectionType: 'unknown',
};

export const useNetworkStatus = () => {
  const { t } = useContext(ContextApp);
  const [networkStatus, setNetworkStatus] = useState<ConnectionStatus>();

  useEffect(() => {
    let active = true;
    let removeListener: (() => void) | undefined;

    Network.getStatus()
      .then((status) => {
        if (active) setNetworkStatus(status);
      })
      .catch(() => {
        if (active) setNetworkStatus(unavailableStatus);
      });

    Network.addListener('networkStatusChange', (status) => {
      if (active) setNetworkStatus(status);
    })
      .then((listener) => {
        removeListener = () => {
          void listener.remove();
        };
        if (!active) removeListener();
      })
      .catch(() => {
        if (active) setNetworkStatus(unavailableStatus);
      });

    return () => {
      active = false;
      removeListener?.();
    };
  }, []);

  const mapStatusName = useCallback(
    (status: ConnectionType): string => {
      switch (status) {
        case 'wifi':
          return t('abm.wifi');
        case 'cellular':
          return t('abm.mobileData');
        case 'none':
          return t('abm.noConnection');
        case 'unknown':
          return t('abm.unknown');
        default:
          return t('abm.unknown');
      }
    },
    [t],
  );

  return { networkStatus, mapStatusName };
};
